import React from "react";
import PropTypes from "prop-types";
import { normalizeImageURLForImageAspectRatioCache } from "utils/normalizeImageURLForImageAspectRatioCache";
import ImageAspectRatioCacheContext from "./ImageAspectRatioCacheContext";

export default class ImageAspectRatioCacheContextProvider extends React.PureComponent {
  state = {
    cache: {},
    cacheImageAspectRatio: (url, aspectRatio) => {
      const normalizedUrl = normalizeImageURLForImageAspectRatioCache(url);

      // Set the cache if it's either not set or if it's ratio has somehow
      // changed. The ratio should never change. If it does, we did a bad job
      // normalizing :shrug:
      if (
        !this.state.cache[normalizedUrl] ||
        this.state.cache[normalizedUrl] !== aspectRatio
      ) {
        this.setState(({ cache }) => ({
          cache: {
            ...cache,
            [normalizedUrl]: aspectRatio,
          },
        }));
      }
    },
  };

  render() {
    return (
      <ImageAspectRatioCacheContext.Provider value={this.state}>
        {this.props.children}
      </ImageAspectRatioCacheContext.Provider>
    );
  }
}

ImageAspectRatioCacheContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
